import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 2000 }
  }

  connect() {
    this.poll()
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  disconnect() {
    this.stop()
  }

  async poll() {
    if (this.requesting) return

    this.requesting = true

    try {
      const response = await fetch(this.urlValue, {
        credentials: "same-origin",
        headers: { Accept: "text/vnd.turbo-stream.html" }
      })

      if (response.status === 204 || !response.ok) return
      if (!response.headers.get("content-type")?.includes("text/vnd.turbo-stream.html")) return

      Turbo.renderStreamMessage(await response.text())
      this.stop()
    } catch {
      // A later poll can recover from a temporary network failure.
    } finally {
      this.requesting = false
    }
  }

  stop() {
    if (this.timer) clearInterval(this.timer)
  }
}
